import { ArticleAttributes } from '@/types/articleTypes';
import generateFAQSchema from './SchemaGeneration/generateFAQSchema';
import generateBlogPostingSchema from './SchemaGeneration/generateBlogPostingSchema';
import { FAQ } from './SchemaGeneration/structuredData';

export interface SchemaStructuredDataProps {
	blogPosting?: ArticleAttributes;
	faq?: FAQ;
	custom?: Record<string, string | Record<string, string>>;
}

const SchemaStructuredData = (props: SchemaStructuredDataProps) => {
	const { blogPosting, faq, custom } = props;

	let structuredData;

	if (faq) {
		structuredData = generateFAQSchema(faq);
	}

	if (blogPosting) {
		// A new field has been created for custom Schemas
		if (blogPosting.seo.customSchema) {
			structuredData = blogPosting.seo.customSchema;
		} else {
			structuredData = generateBlogPostingSchema(blogPosting);
		}
	}

	if (custom) {
		structuredData = custom;
	}

	if (!structuredData) {
		return null;
	}

	return (
		<script
			type="application/ld+json"
			dangerouslySetInnerHTML={{
				__html: JSON.stringify(structuredData),
			}}
		/>
	);
};

export default SchemaStructuredData;
